import Swiper from 'swiper';
// import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const LoadSwiperSlider = (function(){

    function wrapGallery(el, wrapper) {
        if (el) {

    let existingWrapper = el.closest('.llqd-carousel');
    if (existingWrapper) {
        wrapper = existingWrapper;
    } else {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.classList.add('llqd-carousel');
        wrapper.appendChild(el);
    }
            var columns = getClassNumber('columns-', el);
            if (columns !== false) wrapper.dataset.items = columns !== 'default' ? columns : 'auto';

            var items = getClassNumber('has-items-', el);
            if (items !== false) wrapper.dataset.items = items;

            var autoplay = getClassNumber('has-autoplay-', el);
            if (autoplay !== false) wrapper.dataset.autoplay = autoplay;

            var speed = getClassNumber('has-speed-', el);
            if (speed !== false) wrapper.dataset.speed = speed;

            if (el.classList.contains('has-controls')) wrapper.dataset.controls = 1;
            if (el.classList.contains('has-nav')) wrapper.dataset.nav = 1;
            if (el.classList.contains('has-responsive')) wrapper.dataset.responsive = 1;
            if (el.classList.contains('has-loop')) wrapper.dataset.loop = 1;

            var spacer = getClassNumber('has-spacer-', el);
            if (spacer !== false) wrapper.dataset.spacer = spacer;

            wrapper.classList.add('llqd-carousel');
            wrapper.appendChild(el);

            if (!wrapper.querySelector('.swiper-pagination')) {
                wrapper.insertAdjacentHTML('beforeend', '<div class="swiper-pagination"></div>');
            }

            for (var i = 0; i < el.children.length; i++) {
                var child = el.children[i];
                child.classList.add("swiper-slide", "position-relative", "overflow-hidden");
            }

            initcarousel(wrapper);
        }
    }

    function initSlideGroup(){
        var setgroups = document.querySelectorAll('.wp-block-group.is-style-llqd-carousel');
        setgroups.forEach(setgroup => {
            if ( ! setgroup.classList.contains('swiper-wrapper')) {
                setgroup.classList.add('swiper-wrapper');
                setgroup.classList.remove('is-layout-flex');
                wrapGallery(setgroup, document.createElement('div'));
            }
        });
    }

    function initSlideLoop(){
        var setgroups = document.querySelectorAll('.wp-block-post-template.is-style-llqd-carousel');
        setgroups.forEach(setgroup => {
            if ( ! setgroup.classList.contains('swiper-wrapper')) {
                setgroup.classList.add('swiper-wrapper');
                setgroup.classList.remove('is-layout-flex');
                wrapGallery(setgroup, document.createElement('div'));
            }
        });
    }

    function initSlideGalleries(){
        var setgalleries = document.querySelectorAll('.wp-block-gallery.is-style-llqd-carousel');
        setgalleries.forEach(setgallery => {
            if ( ! setgallery.classList.contains('swiper-wrapper')) {
                setgallery.classList.add('swiper-wrapper', 'lliquid-gallery');
                setgallery.classList.remove('is-layout-flex');
                removeClassesPrefix('wp-block-gallery', setgallery);
                removeClassesPrefix('wp-container', setgallery);
                wrapGallery(setgallery, document.createElement('div'));
            }
        });
    }

    function removeClassesPrefix(prefix, el){
        const classes = el.className.split(" ").filter(c => !c.startsWith(prefix));
        el.className = classes.join(" ").trim();
    }

    function getClassNumber(prefix, el){
        const classes = el.className.split(" ").filter(c => c.startsWith(prefix));
        if (classes.length > 0) {
            const splitclass = classes[0].split(prefix);
            if (splitclass.length > 1) {
                return splitclass[1];
            }
        }
        return false;
    }

    function initcarousel(slider){
        if (slider.classList.contains('swiper-initialized')) return;
        if (!slider || !slider.isConnected) return;

        slider.classList.add('swiper');
        var items = slider.dataset.items || 1;
        var sliderAtts = {
            slidesPerView: items,
            spaceBetween: slider.dataset.spacer ? Number(slider.dataset.spacer) : 0,
        };

        if (slider.hasAttribute("data-controls")) {
            if (Boolean(Number(slider.dataset.controls))) {
                slider.insertAdjacentHTML( 'beforeend', '<div class="swiper-pagination"></div>' );
                sliderAtts.pagination = {
                    el: ".swiper-pagination",
                    clickable: true,
                };
            }
        }

        if (slider.hasAttribute("data-nav")) {
            if (Boolean(Number(slider.dataset.nav))) {
                slider.insertAdjacentHTML( 'beforeend', '<div class="swiper-button-next"></div><div class="swiper-button-prev"></div>' );
                sliderAtts.navigation = {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }; 
            }
        }

        if (slider.hasAttribute("data-autoplay")) {
            if (Number(slider.dataset.autoplay) > 1) {
                sliderAtts.autoplay = { delay: slider.dataset.autoplay }
            } else {
                sliderAtts.autoplay = Boolean(Number(slider.dataset.autoplay));
            }
            sliderAtts.disableOnInteraction = false;
        }

        if (slider.hasAttribute("data-speed")) {
            sliderAtts.speed = Number(slider.dataset.speed);
        }

        if (slider.hasAttribute("data-responsive")) {
            if (Boolean(Number(slider.dataset.responsive))) {
                sliderAtts.slidesPerView = Math.max((items - 4), 1);
                sliderAtts.breakpoints = {
                    '576': { slidesPerView: Math.max((items - 3), 1) },
                    '768': { slidesPerView: Math.max((items - 2), 1) },
                    '992': { slidesPerView: Math.max((items - 1), 1) },
                    '1200': { slidesPerView: items }
                };
            }
        }

        sliderAtts.loop = Boolean(Number(slider.dataset.loop));
// console.log(sliderAtts);
        const newSlider = new Swiper(slider, sliderAtts);

        slider.swiperInstance = newSlider;

        newSlider.on("slideChangeTransitionEnd", function(){
            newSlider.updateAutoHeight(5000);
        });
        newSlider.on('slideChange', function () {
            if (newSlider.autoplay && newSlider.autoplay.running) {
                newSlider.autoplay.stop();
                newSlider.autoplay.start();
            }
        });
    }

    function init(){
        initSlideGalleries();
        initSlideGroup();
        initSlideLoop();

        document.querySelectorAll('.llqd-carousel').forEach(slider => {
            if (slider.isConnected) {
                initcarousel(slider);
            }
        });
    }

    function reinit() {
        const blocks = document.querySelectorAll('.is-style-llqd-carousel');

        blocks.forEach(block => {
            if (!block || !block.isConnected) return;

            const oldWrapper = block.closest('.llqd-carousel');

            if (oldWrapper && oldWrapper.swiperInstance) {
                oldWrapper.swiperInstance.destroy(true, true);
                delete oldWrapper.swiperInstance;
            }

            Array.from(block.children).forEach(child => {
                child.classList.remove('swiper-slide', 'position-relative', 'overflow-hidden');
            });

            if (oldWrapper) {
                oldWrapper.querySelectorAll('.swiper-pagination, .swiper-button-next, .swiper-button-prev').forEach(el => el.remove());
            }

            let wrapper;
            if (oldWrapper) {
                wrapper = oldWrapper;
            } else {
                wrapper = document.createElement('div');
                wrapper.classList.add('llqd-carousel');
                block.parentNode.insertBefore(wrapper, block);
            }

            if (!block.classList.contains('swiper-wrapper')) {
                block.classList.add('swiper-wrapper');
                block.classList.remove('is-layout-flex');
            }

            wrapper.appendChild(block);

            if (!wrapper.querySelector('.swiper-pagination')) {
                wrapper.insertAdjacentHTML('beforeend', '<div class="swiper-pagination"></div>');
            }

            Array.from(block.children).forEach(child => {
                child.classList.add('swiper-slide', 'position-relative', 'overflow-hidden');
            });

            initcarousel(wrapper);
        });
    }

    return { init, reinit, initcarousel };
}());

var LlqdCarousel = (function() {
    var initialized = false;

    function init() {
        if (!initialized) {
            LoadSwiperSlider.init();
            initialized = true;
        }
    }

    return {
        init: init,
        reinit: LoadSwiperSlider.reinit
    };
})();

window.LlqdCarousel = LlqdCarousel;
LlqdCarousel.init();
